import React from 'react';
import { Checkbox } from '@/lib/components/ui/checkbox';

const CheckboxComponent = ({
  onChange,
  name,
  value,
  label,
  defaultChecked,
  className,
}: {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
  value: string;
  label: string;
  defaultChecked: boolean;
  className?: string;
}) => {
  return (
    <div className={`flex items-center ${className || ''}`} key={value}>
      <label className="flex items-center gap-2 text-sm cursor-pointer">
        <Checkbox
          name={name}
          value={value}
          onCheckedChange={(checked) => {
            // Simulate an event for compatibility
            const event = {
              target: { name, value, checked },
            } as React.ChangeEvent<HTMLInputElement>;
            onChange(event);
          }}
          defaultChecked={Boolean(defaultChecked)}
          className="h-4 w-4"
        />
        <span className="text-gray-700">{label}</span>
      </label>
    </div>
  );
};

export default CheckboxComponent;
